import { render, staticRenderFns } from "./BulkItemStatusIndicator.vue?vue&type=template&id=6f465a45&scoped=true"
import script from "./BulkItemStatusIndicator.vue?vue&type=script&lang=js"
export * from "./BulkItemStatusIndicator.vue?vue&type=script&lang=js"
import style0 from "./BulkItemStatusIndicator.vue?vue&type=style&index=0&id=6f465a45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f465a45",
  null
  
)

export default component.exports